import React, { Component } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class PEFundTransactionsAnalysis extends Component {
    constructor(props) {
        super(props);
        const url = this.props.selector != null ? this.props.selector.split('/') : [];

        this.state = {
            investor: (url[0] != null && url[0] !== '') ? decodeURIComponent(url[0]).replace(/\//g, '-') : '',
            fund: (url[1] != null && url[1] !== '') ? decodeURIComponent(url[1]).replace(/\//g, '-') : '',
            investors: [],
            funds: [],
            data: [],
            sheetData: [],
            clientList: this.props.filterClients(),
            filter: {},
            sort: '',
            sortType: 'text',
            sortAsc: true,
            dbField: false,
            headers: [
                { display: 'Investor', accessors: ['investor'], filter: true, width: 18 },
                { display: 'Fund', accessors: ['fund'], filter: true, width: 64 },
                { display: 'Transaction Type', accessors: ['tranType'], width: 20 },
                { display: 'Trade Date', accessors: ['tradeDate'], type: 'date', filter: true, classNames: 'text-center', width: 12 },
                { display: 'Quantity', accessors: ['quantity'], type: 'number', classNames: 'text-right', width: 12 },
                { display: 'Price', accessors: ['price'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Amount', accessors: ['amount'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Dividend Rate', accessors: ['dividendRate'], type: 'number', classNames: 'text-right', width: 12 },
                { display: 'Commitment', accessors: ['commitment'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Remaining Commitment', accessors: ['remainingCommitment'], type: 'currency', classNames: 'text-right', width: 20 },
                { display: 'Pre Funding', accessors: ['preFunding'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Cost', accessors: ['cost'], type: 'currency', classNames: 'text-right', width: 12 },
                { display: 'Value', accessors: ['value'], type: 'currency', classNames: 'text-right', width: 12 },
            ]
        };
    }

    componentDidMount() {
        this.props.log('PEFundTransactionsAnalysis.js/componentDidMount');
        this.getInvestors(); this.getFunds(); this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
        this.props.passHeaders(this.state.headers, this.callback);
    }

    callback = (headers) => {
        this.props.log('PEFundTransactionsAnalysis.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getFormattedDate = (date) => {
        this.props.info('TransactionList.js/getFormattedDate (date)', date);
        let year = date.getFullYear()//.toString().substr(2, 2);
        let month = (1 + date.getMonth())/*.toString().padStart(2, '0')*/;
        let day = date.getDate()/*.toString().padStart(2, '0')*/;
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type, hide) => {
        this.props.info('TransactionList.js/getFormattedField (val,type, hide)', val, type, hide);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2)));
            case "datetime":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2))) + ' ' + this.formatAMPM(new Date(val));
            case "number":
                return Intl.NumberFormat().format(parseFloat(val));
            case "currency":
                if (hide == null) {
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }).format(val);
                } else if (hide) {
                    return val
                }
                break;
            default:
                return val;
        }
    }

    getInvestors = () => {
        this.props.log('TransactionList.js/getInvestors');
        fetch('/api/reports/InvestorListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        investors: results.data.map(item => { return (item.data != null && item.data.companyName != null) ? item.data.companyName : null })
                    });
                } else {
                    this.props.addToast('Unable to get investors.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFunds = () => {
        this.props.log('TransactionList.js/getFunds');
        fetch('/api/reports/FundListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        funds: results.data.map(item => { return (item.data != null && item.data.fundName != null) ? item.data.fundName : null })
                    });
                } else {
                    this.props.addToast('Unable to get funds.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('PEFundTransactionsAnalysis.js/onSubmit');
        fetch('/api/reports/PEFundTransactionsAnalysis', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
            body: JSON.stringify([
                { key: 'investor', type: 'nvarchar', value: this.state.investor !== '' ? this.state.investor : null },
                { key: 'fund', type: 'nvarchar', value: this.state.fund !== '' ? this.state.fund : null },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: this.prepareData(results.data)
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    prepareData = (data) => {
        this.props.log('PEFundTransactionsAnalysis.js/prepareData');
        let investor = '';
        let fund = '';
        let commitment = 0;
        let remainingCommitment = 0;
        let cost = 0;
        let value = 0;
        data.forEach(row => {
            let ignoreCost = false;
            let ignoreValue = false;
            if (row.investor !== investor || row.fund !== fund) {
                investor = row.investor;
                fund = row.fund;
                commitment = 0;
                remainingCommitment = 0;
                cost = 0;
                value = 0;
            }
            switch (row.tranType) {
                case "Buy":
                    cost += parseFloat(row.amount);
                    ignoreValue = true;
                    row.value = value + parseFloat(row.amount);
                    remainingCommitment -= Math.max(commitment > 0 ? parseFloat(row.amount) : 0, 0);
                    break;
                case "Capital Call":
                    // row.cost = 
                    cost += parseFloat(row.amount);
                    row.value = value + parseFloat(row.amount);
                    // ignoreCost = true;
                    ignoreValue = true;
                    remainingCommitment -= Math.max(commitment > 0 ? parseFloat(row.amount) : 0, 0);
                    break;
                case "Sell":
                    cost -= parseFloat(row.amount);
                    remainingCommitment += Math.max(commitment > 0 ? parseFloat(row.amount) : 0, 0);
                    break;
                case "Return of Callable Capital":
                    // row.cost =
                    cost -= parseFloat(row.amount);
                    // ignoreCost = true;
                    ignoreValue = true;
                    remainingCommitment += Math.max(commitment > 0 ? parseFloat(row.amount) : 0, 0);
                    break;
                case "Pre-Funding":
                    row.preFunding = parseFloat(row.amount)
                    break;
                case "Commitment":
                    commitment = parseFloat(row.amount);
                    remainingCommitment = parseFloat(row.amount);
                    break;
                case "Transfer In":
                    cost += parseFloat(row.amount);
                    break;
                case "Transfer Out":
                    cost -= parseFloat(row.amount);
                    break;
                case "Valuation":
                case "Valuation ($1 Price)":
                    value = parseFloat(row.amount);
                    break;
                case "Dividend":
                    // row.value = cost;
                    // ignoreValue = true;
                    break;
                case "Late Interest":
                    break;
                default:
                    break;
            }
            row.commitment = commitment !== 0 ? commitment : '';
            row.remainingCommitment = remainingCommitment !== 0 ? remainingCommitment : '';
            if (!ignoreCost) row.cost = cost !== 0 ? cost : '';
            if (!ignoreValue) row.value = (value !== 0 && row.tranType.indexOf('Valuation') > -1) ? value : '';
        })
        let retArr = data.map(row => { return ({ data: row, formEntryId: 0 }) })
        return retArr;
    }

    getCSVdata = () => {
        this.props.log('PEFundTransactionsAnalysis.js/getCSVdata');
        if (this.state.data.length === 0 /*|| parseInt(this.state.fund) === 0 || this.state.fund === ''*/) {
            this.props.passData([], '');
        } else {
            const retArr = [
                ['Investor', 'Fund'],
                [
                this.state.investor,
                this.state.fund
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header) => (
                    header.display
                ))
            ]).concat(
                this.state.data.map(row => {
                    let retArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        retArray[headerIndex] = !isNaN(parseFloat(row.data[header.accessors[0]])) && headerIndex >= 4 ? parseFloat(row.data[header.accessors[0]]) : this.getFormattedField(row.data[header.accessors[0]], header.type, true);

                    });
                    return retArray;
                })
            );
            const styleArr = [
                [
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                ],
                [
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    { s: { font: { bold: true } } }
                ))
            ]).concat(
                this.state.data.map(row => {
                    let styleArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        switch (headerIndex) {
                            case 4:
                            case 7:
                                // numeric
                                styleArray[headerIndex] = {
                                    // data row
                                    z: '###,##0'
                                };
                                break;
                            case 5:
                            case 6:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                                // any currency columns
                                styleArray[headerIndex] = {
                                    // data row
                                    z: '$###,##0.00'
                                };
                                break;
                            default:
                                styleArray[headerIndex] = null
                        }
                    })
                    return styleArray;
                })
            );
            this.props.passData(retArr, "pe-fund-transactions-analysis" , styleArr);
        }
    }

    onChange = (e) => {
        this.props.log('PEFundTransactionsAnalysis.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let value = '';
        let refresh = true;
        this.setState((prevState) => {
            let sel = prevState;
            sel[e.target.name] = (e.target.value);
            value = ((sel.investor) === '' ? '' : encodeURIComponent(sel.investor)) + '/' + ((sel.fund) === '' ? '' : encodeURIComponent(sel.fund));
            if (e.target.name === 'investor' && e.target.value === '0') {
                sel.investor = '';
                value = ((sel.fund !== '') ? '/' + sel.fund : '/');
            }
            if (e.target.name === 'fund' && e.target.value === '0') {
                sel.fund = '';
                value = ((sel.investor !== '') ? sel.investor + '/' : '/');
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    onChangeFilter = (e) => {
        this.props.log('PEFundTransactionsAnalysis.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('PEFundTransactionsAnalysis.js/render');
        return (
            <>
                <Row className="mb-4 noPrint">
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Investor
                            <Input type="select" className="companySelect w-100" name="investor" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.investor).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.investors.map(investor => (
                                    <option key={investor} value={this.props.replaceSpecialChars(this.props.isFieldNull(investor).replace(/\//g, '-'))}>{investor}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Fund
                            <Input type="select" className="companySelect w-100" name="fund" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.fund).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.funds.map(fund => (
                                    <option key={fund} value={this.props.replaceSpecialChars(this.props.isFieldNull(fund).replace(/\//g, '-'))}>{fund}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                </Row>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th
                                        className={header.classNames}
                                        // className='pointer'
                                        // onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc, header.dbField))}
                                        key={"sort" + headerIndex}>
                                        {header.display}
                                        {/* {header.accessors[0] === this.state.sort ? <span className="sortChevron">
                                            <FontAwesomeIcon icon={this.state.sortAsc ? faChevronUp : faChevronDown} />
                                        </span> : null} */}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={"filter" + headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ? this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.orderEntries(this.state.data, { uniqueId: this.state.sort, asc: this.state.sortAsc, type: this.state.sortType }, this.state.dbField).filter(entry => {
                                let temp = true;
                                Object.keys(this.state.filter).forEach(field => {
                                    if ((entry.data[field] != null && this.state.filter[field] != null &&
                                        (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                        ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                })
                                return temp;
                            }).map((row, rowIndex) => (
                                <tr key={"data" + rowIndex}>
                                    {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                        <td className={(header.dbField ? "dbField" : "") +
                                            " " + header.classNames} key={"header" + headerIndex}>{header.dbField ?
                                                this.getFormattedField(row[header.accessors[0]], header.type)
                                                : this.getFormattedField(row.data[header.accessors[0]], header.type)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    : <>No results</>}
            </>
        );

    }
}

export default PEFundTransactionsAnalysis;
